export const ADMIN = 'ADMIN';
export const EXEC = 'EXEC';
export const EARLY = 'EARLY';